import { api } from '../index';
import axios from 'axios';

const silent_api = axios.create();
silent_api.defaults.baseURL = process.env.VUE_APP_API_URL;
silent_api.defaults.withCredentials = true;

const prefix = '/api/call_tag/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectCallTagList(param) {
	return api.post(prefix + 'selectCallTagList', param);
}

export function apiSelectCallTag(param) {
	return api.post(prefix + 'selectCallTag', param);
}

export function apiInsertCallTag(param) {
	param.mode = 'insert';
	return apiSubmitCallTag(param);
}

export function apiUpdateCallTag(param) {
	param.mode = 'update';
	return apiSubmitCallTag(param);
}

function apiSubmitCallTag(param) {
	return api.post(prefix + 'submitCallTag', param);
}

export function apiVoidCallTag(param) {
	return api.post(prefix + 'voidCallTag', param);
}

export function apiReviveCallTag(param) {
	return api.post(prefix + 'reviveCallTag', param);
}

export function apiSelectCallTagItemList(param) {
	return api.post(prefix + 'selectCallTagItemList', param);
}

export function apiCheckTrackingStatus(param) {
	return silent_api.post(prefix + 'checkTrackingStatus', param);
}
